import { AxiosError } from "axios";
import _get from "lodash/get";
import FrontApiError from "./FrontApiError";

export default class FrontApiErrorDto {
    static httpErrorToFrontApiError(e: AxiosError) {
        if (e) {
            const status: number = _get(e, "response.status", 500);
            return new FrontApiError(status, _get(e, "response.data", {}));
        }
        return new FrontApiError(500, "undefined error");
    }
}
